import React, { useEffect } from "react";

/**
 * Carrega os CSS/JS originais do seu pacote no <head>/<body>.
 * 👉 Ajuste os caminhos conforme o seu ZIP.
 */
const cssHrefs = [
  "/pkg/css/style.css",
  // adicione aqui outros CSS do seu pacote, se houver
];
const jsSrcs = [
  "/pkg/js/main.js",
  // adicione aqui outros JS do seu pacote, se houver
];

export default function HtmlHeadInjector({ title = "Landing" }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const links = cssHrefs.map((href) => {
      const l = document.createElement("link");
      l.rel = "stylesheet";
      l.href = href;
      document.head.appendChild(l);
      return l;
    });

    const scripts = jsSrcs.map((src) => {
      const s = document.createElement("script");
      s.src = src;
      s.defer = true;
      document.body.appendChild(s);
      return s;
    });

    return () => {
      document.title = prevTitle;
      links.forEach((l) => l.remove());
      scripts.forEach((s) => s.remove());
    };
  }, [title]);

  return null;
}
